import React, { useState, useEffect } from 'react';
// import CKEditor from 'ckeditor4-react';
import CKEditor from 'components/elements/CKEditor';
import { connect } from 'react-redux';

const mapStateToProps = (state) => ({
	CSRFToken: state.app.CSRFToken,
	stApp: state, 
});

const TextTabsEditor = ({ isAllowed, submitTabText, tabData, dict, CSRFToken, stApp, type, id }) => {
	const [ckText, setCkText] = useState('');
	const [initialData, setInitialData] = useState(null);

	const onSubmit = () => {
		submitTabText(ckText);
	}
	const onEditorChange = (evt) => {
		setCkText(evt.editor.getData());
	}
	useEffect(() => {
		setInitialData(tabData);
	}, [tabData]);

	if (!isAllowed) {
		return <div className="text-tabs__editor">
		  <div className="text-tabs__editor__static"
			dangerouslySetInnerHTML={{
			__html: initialData
		  }}></div>
		</div>
	  }

	return (
		<>
		<CKEditor
			initialData={initialData}
			data={ckText}
			onEditorChange={onEditorChange}
			CSRFToken={CSRFToken}
			type={type}
			id={id}
		></CKEditor>
		<div className="text-tabs__buttons">
				<button onClick={()=>onSubmit()} className= {`text-tabs__button`}>
					{dict[`form.save`]}
				</button>
			</div>
			{/* <CKEditor
				config={
					{
						// extraPlugins: 'easyimage',
						// removePlugins: 'image',
						toolbar: [
							{ name: 'document', items: ['Source'] },
							{ name: 'clipboard', groups: ['clipboard', 'undo'], items: ['PasteText', '-', 'Undo', 'Redo'] },
							{ name: 'basicstyles', groups: ['basicstyles', 'cleanup'], items: ['Bold', 'Italic', 'Subscript','Superscript', '-', 'RemoveFormat'] },
							{ name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi'], items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
							'/',
							{ name: 'links', items: ['Link', 'Unlink'] },
							{ name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar'] },	
							{ name: 'styles', items: ['Format'] },
						],

						extraPlugins: 'uploadimage,image2',
						height: 400,

						fileTools_requestHeaders: {
							'X-CSRF-TOKEN': CSRFToken,
						},
						uploadUrl: `/api/flat/save-image/${type}/${id}`,
						filebrowserImageUploadUrl: '/api/flat/save-image/policy/1',
						image2_alignClasses: ['image-align-left', 'image-align-center', 'image-align-right'],
						image2_disableResizer: true
					}
				}
				data={ckText}
				onChange={onEditorChange}
			/>
			<div className="text-tabs__buttons">
				<button onClick={()=>onSubmit()} className= {`text-tabs__button`}>
					{dict[`form.save`]}
				</button>
			</div> */}
		</>
	)
}
export default connect(mapStateToProps)(TextTabsEditor);